import { get, post, put } from "../services/HttpService";
import { beneficiaryNameRegex, size_greater_than } from "../app_methods";
import { axiosIns } from "../services";


export class BulkUploadBatch {
    constructor(bulkUploadBatchObject = {}) {
        this.set(bulkUploadBatchObject);
    };

    static validations = {
        "id": [],
        "uuid": [],
        "created_at": [],
        "batch_type": [],
        "name": [
            { required: true, message: "Batch name is required." },
            {pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "file": [
            {
                validator: (rule, value, callback) => {
                    if (!value) { callback(true); return; }
                    const file = value.file;
                    size_greater_than(file, 1000000) ? callback(true) : callback();
                },
                message: "File is required and its size cannot exceed 1 MB."
            }
        ],
        "threshold_percentage": [
            {pattern: /^100(\.0{1,2})?$|(^([1-9]([0-9])?)(\.[0-9]{1,2})?)$/, message: "Please enter a valid Percentage"},
            { max: 100, message: "Maximum 100 percentage is allowed" }
        ],
        "continue_on_error": []
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/batches/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    fetch_records_v2 = (queryData = {}, config = {}) => {
        let uri = `v2/internal/batches/${this.uuid}/fetch_records/`
        return get(uri, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
        static list_v2 = (queryData = {}, config = {}) => {
            return get(`v2/internal/batches/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    fetch_records = (queryData = {}, config = {}) => {
        let uri = `v1/internal/batches/${this.uuid}/fetch_records/`
        return get(uri, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    static fetch_transfers = (queryData = {}, config = {}) => {
        return get(`v1/internal/batches/fetch_transfers/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    static downloadTemplate = (queryData = {}, config = {}) => {
        let uri = 'v1/internal/batches/download_template/'
        if (['vendor','vendor_invoice'].includes(queryData.batch_type)){
            uri = `/vendor-payouts/v1/internal/batches/download_template/`
        }
        return axiosIns.request({
            url: uri,
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    validate = (queryData = {}) => {
        queryData = { ...queryData, ...this.get()};
        let uri = `v1/internal/batches/validate/`
        if (['vendor','vendor_invoice'].includes(queryData.batch_type)){
            uri = `/vendor-payouts/v1/internal/batches/validate/`
        }
        let formData = new FormData();
        formData.append("key", queryData.key);
        formData.append("name", queryData.name);
        formData.append("batch_type", queryData.batch_type);
        formData.append("file", queryData.file.file);
        formData.append("queue_on_low_balance", queryData.queue_on_low_balance);
        formData.append("virtual_account_number", queryData.virtual_account_number);
        formData.append("continue_on_error", queryData.continue_on_error)
        return post(uri, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    validateAndProcess = (queryData = {}) => {
        queryData = { ...queryData, ...this.get()};
        let uri = `v1/internal/batches/validate_and_process/`
        let formData = new FormData();
        formData.append("key", queryData.key);
        formData.append("name", queryData.name);
        formData.append("batch_type", queryData.batch_type);
        formData.append("file", queryData.file.file);
        formData.append("queue_on_low_balance", queryData.queue_on_low_balance);
        formData.append("virtual_account_number", queryData.virtual_account_number);
        formData.append("continue_on_error", queryData.continue_on_error)
        formData.append("onboard_on_sbi", queryData.onboard_on_sbi || false);
        return post(uri, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    process = (queryData = {}) => {
        queryData = { ...queryData, ...this.get()};
        let uri = `v1/internal/batches/process/`
        if (['vendor','vendor_invoice'].includes(queryData.batch_type)){
            uri = `/vendor-payouts/v1/internal/batches/process/`
        }
        let formData = new FormData();
        formData.append("key", queryData.key);
        formData.append("name", queryData.name);
        formData.append("batch_type", queryData.batch_type);
        formData.append("file", queryData.file.file);
        formData.append("queue_on_low_balance", queryData.queue_on_low_balance);
        formData.append("virtual_account_number", queryData.virtual_account_number);
        formData.append("threshold_percentage", queryData.threshold_percentage || '');
        return post(uri, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    approve_batch = (queryData = {}) => {
        return post(`v1/internal/approval/${queryData.approval_id}/update_batch/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    export = (queryData = {}, config = {}) => {
        queryData = { ...queryData, ...this.get()};
        let uri = `v1/internal/batches/export/`
        if (['vendor','vendor_invoice'].includes(queryData.batch_type)){
            uri = `/vendor-payouts/v1/internal/batches/export/`
        }
        return axiosIns.request({
            url: uri,
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    };

    /**
     * @memberof BulkUploadBatch
     * @type API
     * @returns Promise
     */
    process_bulk_on_bank = (queryData={})=>{
            return post(`v1/internal/batches/process_bulk_on_bank/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    
    /**
     * @memberof BulkUploadBatch
     * @type Getter Method
     * @takes void
     * @returns BulkUploadBatch Params
     */
    get = () => {
        return {
            uuid: this.uuid,
            name: this.name,
            file: this.file,
            batch_type: this.batch_type,
            queue_on_low_balance: this.queue_on_low_balance,
            threshold_percentage: this.threshold_percentage,
            virtual_account_number: this.virtual_account_number,
            otp_details:this.otp_details,
            onboard_on_sbi:this.onboard_on_sbi
        }
    };

    /**
     * @memberof BulkUploadBatch
     * @type Setter Method
     * @takes BulkUploadBatch Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}